import { render, staticRenderFns } from "./indexColor.vue?vue&type=template&id=4ce507e2&scoped=true"
import script from "./indexColor.vue?vue&type=script&lang=js"
export * from "./indexColor.vue?vue&type=script&lang=js"
import style0 from "./indexColor.vue?vue&type=style&index=0&id=4ce507e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce507e2",
  null
  
)

export default component.exports